import BotConditionCard from "./BotConditionCard";
import React from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormChipInput from "../../input/ReactHookFormChipInput";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton} from "@mui/material";

function BotConditionUserAgent(props) {
    const {control, setValue, getValues} = props;

    // Watch rules object in real-time
    const rules = useWatch({control, name: "rules"}) || {};
    const userAgentData = rules?.userAgent;
    const hasUserAgentCondition = !!userAgentData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
        {label: "Contains", value: "contains", color: "primary"},
        {label: "Not contain", value: "notContain", color: "error"},
    ];

    // REMOVE: Safe JS delete approach
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules.userAgent;
        setValue("rules", currentRules);
    };

    // ADD: Initialize flat userAgent object
    const addCondition = () => {
        setValue("rules.userAgent", {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasUserAgentCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>User agent</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasUserAgentCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            User agent
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.userAgent.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="rules.userAgent.includeEmptyValue"
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <ReactHookFormChipInput
                            control={control}
                            name="rules.userAgent.values"
                            label="User agent"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionUserAgent;
